import { render, staticRenderFns } from "./AuditLogView.vue?vue&type=template&id=08fcc366&scoped=true"
import script from "./AuditLogView.vue?vue&type=script&lang=js"
export * from "./AuditLogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fcc366",
  null
  
)

export default component.exports